<template>
  <div class="main print-no-padding agreement">
    <h2 class="is-print-hide title-area">
      <span class="main-title">协议中心</span>
    </h2>
    <el-breadcrumb class="breadcrumb" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/agreementList' }">协议中心</el-breadcrumb-item>
      <el-breadcrumb-item>协议详情</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="list-content">
      <iframe width="100%" height="100%" :src="url" frameborder="0"></iframe>
    </div>
    <transition name="stretch">
      <div class="control-bar" v-if="signStatus === 0">
        <div class="control">
          <el-checkbox v-model="checked">已阅读并同意上述协议</el-checkbox>
        </div>
        <div class="button-group">
          <div class="button primary" @click="cancelAgreement">暂不签署</div>
          <div class="button" :class="!checked && 'disabled'" @click="submitAgreement">确认并签署协议</div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import Vue from 'vue';
import { Checkbox, Breadcrumb, BreadcrumbItem } from 'element-ui';
import agreementDialog from './components/agreementDialog';

Vue.use(Checkbox);
Vue.use(Breadcrumb);
Vue.use(BreadcrumbItem);

export default {
  data() {
    return {
      checked: false,
      url: '',
      signStatus: '0'
    };
  },
  created() {
    Fetch.get_agreement_detail(this.$route.params.id).then(({ url, signStatus }) => {
      this.url = url;
      this.signStatus = signStatus;
    });
  },
  methods: {
    submitAgreement() {
      const { checked } = this;
      if (checked) {
        Fetch.update_agreement_sign(this.$route.params.id).then(_ => {
          this.$message.success('签署协议成功！');
          this.$router.push('/agreementList');
        });
      }
    },
    cancelAgreement() {
      const manager =
        this.$store.state.global.storeList && this.$store.state.global.storeList.length > 0
          ? this.$store.state.global.storeList[0]
          : {};
      agreementDialog.show({
        id: this.$route.params.id,
        principal: this.$checkPower('a'),
        content: `若不签署该协议，将无法通过本平台药师进行处方审核，您可在后台配置门店药师进行审方操作。如有疑问请联系业务经理：${
          manager.saleName || ''
        } ${manager.saleMobile || ''}`,
        redirectUrl: '/agreementList'
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.agreement {
  .title-area {
    margin-bottom: 16px;
  }

  .main-title {
    line-height: 30px;
  }

  .breadcrumb {
    margin-bottom: 16px;
  }

  .list-content {
    margin-bottom: 48px;
    padding: 10px 16px;
    background: #ffffff;
    border: 1px solid #f2f2f2;
    box-shadow: 0 4px 12px 0 #ededed;
    border-radius: 4px;
    height: calc(100vh - 116px);
  }
}

.fade-transform-enter-active {
  .control-bar {
    opacity: 0;
  }
}

.control-bar {
  position: fixed;
  bottom: 0;
  left: 240px;
  z-index: 9;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 48px;
  width: calc(100vw - 240px);
  height: 48px;
  background: #fff;
  border-top: solid 1px #ededed;
  box-shadow: 0 4px 12px 0 rgba(237, 237, 237, 1);

  .control {
  }

  .button-group {
    display: flex;

    .button {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 132px;
      height: 32px;
      font-size: 12px;
      color: #fff;
      background: #1e8dff;
      border-radius: 3px;
      cursor: pointer;

      &.primary {
        margin-right: 16px;
        color: #1e8dff;
        background: #fff;
        border: 1px solid #1e8dff;
      }

      &.disabled {
        opacity: 0.5;
        cursor: default;
      }
    }
  }
}

.stretch-enter-active {
  max-height: 500px;
  transition: all 0.3s;
}

.stretch-enter {
  height: 0;
}
</style>
